/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import { checkIfEveryObjectValueIsEmpty, checkIfObjectHasEmptyValues } from '@avtechsoftware/ra-javascript-utilities/src/utilities/validation/ObjectListUtils';
import GenerateReferralButton from '../GenerateReferralButton/GenerateReferralButton';
import envConfig from '../../../envConfig';
import ReferralAddressBox from '../ReferralAddressBox/ReferralAddressBox';
import ReferralTransactionTable from '../ReferralTransactionTable/ReferralTransactionTable';
import { connectModalContainerContextToComponent } from '../../../contexts/ModalContext/ModalContext';
import EditReferralAddressModal from '../EditReferralAddressModal/EditReferralAddressModal';
import convertNumberToFinancialString from '../../../utility/convertNumberToFinancialString';
import {
  getDateDropDownOptionsFinancialQuarters,
  getQuarterStartAndEndTimestamps,
} from '../../../utility/DateOptionUtility';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';

class ReferralsView extends React.Component {
  constructor(props) {
    super(props);
    const { referralAddress } = this.props;
    const dateOptions = getDateDropDownOptionsFinancialQuarters(8);
    this.state = {
      error: false,
      errorMessage: '',
      submitting: false,
      address: referralAddress,
      dateValue: dateOptions[0].value,
      dateOptions,
    };
    this.generateCode = this.generateCode.bind(this);
    this.handleOpenEditAddressForm = this.handleOpenEditAddressForm.bind(this);
    this.handleDismissError = this.handleDismissError.bind(this);
    this.handleTimeRangeUpdate = this.handleTimeRangeUpdate.bind(this);
    this.handleCreateAddress = this.handleCreateAddress.bind(this);
    this.handlePatchAddress = this.handlePatchAddress.bind(this);
    this.handleClearAddress = this.handleClearAddress.bind(this);
    this.handleSubmitAddress = this.handleSubmitAddress.bind(this);
    this.handleCopyToClipboard = this.handleCopyToClipboard.bind(this);
    this.getTransactionsDataByDate = this.getTransactionsDataByDate.bind(this);
  }

  generateCode() {
    const { userId } = this.props;
    this.setState({ submitting: true });
    return RaaAuthenticatedRemoteService.globalInstance().post(`${envConfig.apiUrl}/api/v1/referral/generate-code/${userId}`)
      .then((referralCodeResponse) => {
        const { userReferralCode } = referralCodeResponse;
        if (!userReferralCode) {
          throw new Error('Could not generate referral code.');
        }
        window.location.reload(true);
      })
      .catch((e) => {
        this.setState({
          error: true,
          errorMessage: e.message,
        });
      })
      .finally(() => this.setState({ submitting: false }));
  }

  handleDismissError() {
    this.setState({ error: false, errorMessage: '' });
  }

  handleOpenEditAddressForm() {
    const {
      setModalJSX,
      countryList,
      referralAddress,
      noAddressForUser,
    } = this.props;
    const defaultAddress = {
      name: '',
      streetLine1: '',
      streetLine2: '',
      locality: '',
      state: '',
      postalCode: '',
      country: '',
    };
    const jsx = (
      <EditReferralAddressModal
        address={noAddressForUser ? defaultAddress : referralAddress}
        submitAddress={this.handleSubmitAddress}
        clearAddress={this.handleClearAddress}
        countries={countryList}
        addressMissing={Object.keys(referralAddress).length <= 0 || checkIfObjectHasEmptyValues({
          name: referralAddress.name,
          streetLine1: referralAddress.streetLine1,
          locality: referralAddress.locality,
          state: referralAddress.state,
          postalCode: referralAddress.postalCode,
        })}
      />
    );
    setModalJSX(jsx);
  }

  getTransactionsDataByDate() {
    const { dateValue } = this.state;
    const { userId } = this.props;
    const { start, end } = getQuarterStartAndEndTimestamps(dateValue);
    return RaaAuthenticatedRemoteService.globalInstance()
      .get(`${envConfig.apiUrl}/api/v1/referral/transaction/find-by-user-date-range?userId=${userId}&startDate=${start}&endDate=${end}`);
  }

  handleTimeRangeUpdate(e) {
    const { value } = e.target;
    this.setState({ dateValue: value });
  }

  handlePatchAddress(editedAddress) {
    const { userId, setModalJSX } = this.props;
    const { address } = this.state;
    const updatedAddress = {
      userId,
      name: editedAddress.name,
      streetLine1: editedAddress.streetLine1,
      streetLine2: editedAddress.streetLine2,
      locality: editedAddress.locality,
      state: editedAddress.state,
      postalCode: editedAddress.postalCode,
      country: editedAddress.country,
      patchFields: [
        'name',
        'streetLine1',
        'streetLine2',
        'locality',
        'state',
        'postalCode',
        'country',
      ],
    };
    RaaAuthenticatedRemoteService.globalInstance().patch(
      `${envConfig.apiUrl}/api/v1/referral/edit-mailing-address/${address.id}`,
      { data: updatedAddress },
    ).then((response) => {
      const { mailingAddress } = response;
      this.setState({ address: mailingAddress });
      setModalJSX(<></>);
      // eslint-disable-next-line no-unused-expressions
      window.location.reload(true);
    // eslint-disable-next-line no-console
    });
  }

  handleCreateAddress(addressToCreate) {
    const { userId, setModalJSX } = this.props;
    const newAddress = {
      userId,
      name: addressToCreate.name,
      streetLine1: addressToCreate.streetLine1,
      streetLine2: addressToCreate.streetLine2,
      locality: addressToCreate.locality,
      state: addressToCreate.state,
      postalCode: addressToCreate.postalCode,
      country: addressToCreate.country,
    };
    RaaAuthenticatedRemoteService.globalInstance().post(
      `${envConfig.apiUrl}/api/v1/referral/create-mailing-address/${userId}`,
      { data: newAddress },
    ).then((response) => {
      const { mailingAddress } = response;
      this.setState({ address: mailingAddress });
      setModalJSX(<></>);
      // eslint-disable-next-line no-unused-expressions
      window.location.reload(true);
    // eslint-disable-next-line no-console
    }).catch((e) => console.log('error creating address', e.message));
  }

  handleSubmitAddress(editedAddress) {
    const { noAddressForUser } = this.props;
    if (noAddressForUser) {
      this.handleCreateAddress(editedAddress);
    } else {
      this.handlePatchAddress(editedAddress);
    }
  }

  handleClearAddress() {
    const { address } = this.state;
    const { setModalJSX } = this.props;
    RaaAuthenticatedRemoteService.globalInstance()
      .delete(`${envConfig.apiUrl}/api/v1/referral/delete-mailing-address/${address.id}`).then(() => {
        this.setState({ address: {} });
        setModalJSX(<></>);
        // eslint-disable-next-line no-unused-expressions
        window.location.reload(true);
        // eslint-disable-next-line no-console
      }).catch((e) => console.log('error deleting address', e.message));
  }

  /* istanbul ignore next */
  // eslint-disable-next-line class-methods-use-this
  async handleCopyToClipboard(copyText) {
    try {
      await navigator.clipboard.writeText(copyText);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Failed to copy to clipboard.', e);
    }
  }

  render() {
    const {
      submitting,
      loading,
      error,
      errorMessage,
      transactionsStart,
      transactionsEnd,
      transactionsError,
      address,
      dateValue,
      dateOptions,
    } = this.state;
    const {
      referralCode,
      rewardsBalance,
    } = this.props;

    if (loading) {
      /* istanbul ignore next */
      return (
        <div className="row d-flex justify-content-center mt-5">
          <div>
            <ProgressSpinner />
          </div>
        </div>
      );
    }

    if (error) {
      /* istanbul ignore next */
      return (
        <div className="row">
          <div className="col">
            <ErrorBanner onCloseError={this.handleDismissError}>
              {errorMessage || 'Unexpected Error.'}
            </ErrorBanner>
          </div>
        </div>
      );
    }

    if (!referralCode) {
      /* istanbul ignore next */
      return (
        <GenerateReferralButton
          submitting={submitting}
          handleGenerateCode={this.generateCode}
        />
      );
    }

    /* istanbul ignore next */
    return (
      <>
        <div className="row">
          <div className="col-8">
            <p>
              <span className="text-nowrap">
                Your personal referral code is
                {' '}
                <strong style={{ fontSize: 'larger' }} className="text-secondary">{referralCode}</strong>
                {' '}
                <button
                  type="button"
                  className="btn btn-link p-0 mb-2"
                  onClick={() => this.handleCopyToClipboard(referralCode)}
                >
                  <Icon icon="copy" />
                </button>
              </span>
              <br />
              Or share this link:
              {' '}
              <span className="text-nowrap">
                <a rel="noopener noreferrer" href={`https://avtech.com?referral=${referralCode}`}>
                  {`https://avtech.com?referral=${referralCode}`}
                </a>
                {' '}
                <button
                  type="button"
                  className="btn btn-link p-0 mb-2"
                  onClick={() => this.handleCopyToClipboard(`https://avtech.com?referral=${referralCode}`)}
                >
                  {' '}
                  <Icon icon="copy" />
                </button>
              </span>
            </p>
          </div>
          <div className="col clearfix">
            <div
              style={{ maxWidth: '50rem' }}
              className="card rounded d-flex justify-content-center float-right-sm px-3"
            >
              <div className="text-center card-body py-2">
                Reward Balance
                <br />
                <div className="alert alert-info rounded mx-3">
                  {' '}
                  <b>
                    <strong>
                      {convertNumberToFinancialString(rewardsBalance)}
                    </strong>
                  </b>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReferralAddressBox
          referralAddress={address}
          handleOpenEditAddressForm={this.handleOpenEditAddressForm}
          addressMissing={Object.keys(address).length <= 0 || checkIfEveryObjectValueIsEmpty({
            name: address.name,
            streetLine1: address.streetLine1,
            locality: address.locality,
            state: address.state,
            postalCode: address.postalCode,
            country: address.country,
          })}
        />
        {
        transactionsError
          ? (
            <div className="row">
              <div className="col">
                <ErrorBanner onCloseError={() => this.setState({ transactionsError: false })}>
                  Error fetching transactions.
                </ErrorBanner>
              </div>
            </div>
          )
          : (
            <ReferralTransactionTable
              handleTimeRangeUpdate={this.handleTimeRangeUpdate}
              start={transactionsStart}
              end={transactionsEnd}
              dateValue={dateValue}
              setError={() => this.setState({ transactionsError: true })}
              fetchTransactions={this.getTransactionsDataByDate}
              dateOptions={dateOptions}
            />
          )
       }
        <div className="my-2">
          <div className="clearfix text-left mt-5">
            <a
              href="/terms/referral-program"
              target="_blank"
              rel="noopener noreferrer"
            >
              Referral Program Terms of Service
            </a>
          </div>
        </div>
      </>
    );
  }
}

ReferralsView.defaultProps = {
  referralCode: '',
  referralAddress: {},
  rewardsBalance: 0,
};

ReferralsView.propTypes = {
  noAddressForUser: PropTypes.bool.isRequired,
  referralCode: PropTypes.string,
  setModalJSX: PropTypes.func.isRequired,
  countryList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    crmId: PropTypes.number,
    code: PropTypes.number,
    name: PropTypes.string,
    abbreviation: PropTypes.string,
  })).isRequired,
  userId: PropTypes.number.isRequired,
  rewardsBalance: PropTypes.number,
  referralAddress: PropTypes.shape({
    id: PropTypes.number,
    userId: PropTypes.number,
    name: PropTypes.string,
    streetLine1: PropTypes.string,
    streetLine2: PropTypes.string,
    locality: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string,
  }),
};

export { ReferralsView };
export default connectModalContainerContextToComponent(
  ReferralsView,
);
